/*
 * "Remove box" in the cart.
 *
 * Gift-box lines have no quantity stepper or delete button of their own (see
 * snippets/pfb-box-line.liquid). This removes every line that shares the box
 * id in one request, then refreshes the drawer in place — or reloads the cart
 * page, where Dawn has no partial renderer to hand the result to.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pfb-remove-box]');
    if (!btn) return;
    event.preventDefault();

    var boxId = btn.dataset.pfbRemoveBox;
    var drawer = btn.closest('cart-drawer');
    btn.disabled = true;
    btn.textContent = 'Removing…';

    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (line) {
          if (line.properties && line.properties['Gift box'] === boxId) updates[line.key] = 0;
        });

        var body = { updates: updates };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          if (state.item_count === 0) drawer.classList.add('is-empty');
          drawer.renderContents(state);
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pfb-box-lock', cartData: state });
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Remove box';
      });
  });
})();
